import { useParams } from 'react-router-dom';
import { getTranslate } from '../../../utils/getTranslate/getTranslate';
import { getRandomArray } from '../../../utils/getRandomArray/getRandomArray';
import color from '../../../data/color/gradient.json';
import styles from './Contact.module.scss';

export const Contact = ({ upContact }) => {
  const t = getTranslate;
  const { lang } = useParams();
  const { address_link, address_text, phone, email, graphics, map_iframe } = upContact.acf;
  const upRanColArr = getRandomArray(color.length, 5);

  console.log(upRanColArr);

  return (
    <section className={styles.info}>
      <div className="container">
        <div className={styles.info_body}>
          <h3 className={`${styles.info_toptitle} global-subtitle`}>{t('Бізбен байланысыңыз', 'Свяжитесь с нами', lang)}</h3>
          <h2 className={`${styles.info_title} global-title`}>{t('Біз әрқашан байланыстамыз', 'Мы всегда открыты для общения', lang)}</h2>
          <p className={`${styles.info_text} global-text`}>
            {t(
              'Кітаптар, іс-шаралар немесе үйірмелер жөнінде сұрақтарыңыз бар ма? Біз сізге көмектесуге дайынбыз!',
              'Есть вопросы по книгам, мероприятиям или работе клубов? Мы на связи и готовы помочь!',
              lang,
            )}
          </p>
          <div className={styles.info_row}>
            <div className={styles.info_info}>
              <div className={styles.info_info_body}>
                <div className={styles.info_info_column}>
                  <div className={styles.info_info_column_body}>
                    <div className={styles.info_info_column_wallpaper} style={{ background: color[upRanColArr[0]] }}></div>
                    <div className={styles.info_info_column_icon}>📍</div>
                    <h4 className={styles.info_info_column_title}>{t('Мекенжай', 'Адрес', lang)}:</h4>
                    <a href={address_link} target="_black" className={`${styles.info_info_column_link} active`}>
                      {address_text[lang]}
                    </a>
                  </div>
                </div>
                <div className={styles.info_info_column}>
                  <div className={styles.info_info_column_body}>
                    <div className={styles.info_info_column_wallpaper} style={{ background: color[upRanColArr[1]] }}></div>
                    <div className={styles.info_info_column_icon}>📞</div>
                    <h4 className={styles.info_info_column_title}>{t('Телефон', 'Телефон', lang)}:</h4>
                    {phone.map((el, idx) => {
                      const { link, text } = el;
                      return (
                        <a key={idx} href={`tel:${link}`} className={`${styles.info_info_column_link} active`}>
                          {text}
                        </a>
                      );
                    })}
                  </div>
                </div>
                <div className={styles.info_info_column}>
                  <div className={styles.info_info_column_body}>
                    <div className={styles.info_info_column_wallpaper} style={{ background: color[upRanColArr[2]] }}></div>
                    <div className={styles.info_info_column_icon}>✉️</div>
                    <h4 className={styles.info_info_column_title}>{t('Email', 'Email', lang)}:</h4>
                    <a href={`mailto:${email}`} className={`${styles.info_info_column_link} active`}>
                      {email}
                    </a>
                  </div>
                </div>
                <div className={styles.info_info_column}>
                  <div className={styles.info_info_column_body}>
                    <div className={styles.info_info_column_wallpaper} style={{ background: color[upRanColArr[3]] }}></div>
                    <div className={styles.info_info_column_icon}>🕒</div>
                    <h4 className={styles.info_info_column_title}>{t('Жұмыс кестесі', 'Режим работы', lang)}:</h4>
                    {graphics
                      .map((el, idx) => {
                        return (
                          <div key={idx} className={styles.info_info_column_link}>
                            {el[lang]}
                          </div>
                        );
                      })
                      .slice(0, 2)}
                  </div>
                </div>
                <div className={styles.info_info_column}>
                  <div className={styles.info_info_column_body}>
                    <div className={styles.info_info_column_wallpaper} style={{ background: color[upRanColArr[4]] }}></div>
                    <div className={styles.info_info_column_icon}>📱</div>
                    <h4 className={styles.info_info_column_title}>{t('Біз әлеуметтік желілерде', 'Мы в соцсетях', lang)}:</h4>
                    <a href="" className={`${styles.info_info_column_link} active`}>
                      {t(
                        'Инстаграм парақшамызға жазылып, жаңалықтардан бірінші болып хабардар болыңыз',
                        'Подписывайтесь на наш Instagram и узнавайте о новинках первыми',
                        lang,
                      )}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.info_map}>
              <div className={styles.info_map_body} dangerouslySetInnerHTML={{ __html: map_iframe }}></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
